import {
	createStore,
	createContainer,
	createStateHook,
	createHook,
	type ContainerComponent,
} from 'react-sweet-state';

type PTV2StoreContainerProps = {
	teamType?: string;
	subAnchor?: string;
	personalSpaceKey: string;
	isTemplateListDismissed?: boolean;
	personalizationHeuristic?: string;
	onboardingPeriodDay?: number;
	isXflow?: boolean;
	source?: string;
};

const PTV2Store = createStore({
	initialState: {
		teamType: '',
		subAnchor: '',
		personalSpaceKey: '',
		isTemplateListDismissed: true,
		personalizationHeuristic: '',
		onboardingPeriodDay: 0,
		isXflow: false,
		source: '',
	},
	actions: {
		setIsTemplateListDismissed:
			(isTemplateListDismissed: boolean) =>
			({ setState }) => {
				setState({ isTemplateListDismissed });
			},
	},
	name: 'PTV2Store',
});

export const usePTV2State = createStateHook(PTV2Store);

export const usePTV2Store = createHook(PTV2Store);

export const PTV2StoreContainer: ContainerComponent<PTV2StoreContainerProps> = createContainer(
	PTV2Store,
	{
		onInit:
			() =>
			(
				{ setState },
				{
					teamType,
					subAnchor,
					personalSpaceKey,
					isTemplateListDismissed,
					personalizationHeuristic,
					onboardingPeriodDay,
					isXflow,
					source,
				},
			) => {
				setState({
					teamType,
					subAnchor,
					personalSpaceKey,
					isTemplateListDismissed,
					personalizationHeuristic,
					onboardingPeriodDay,
					isXflow,
					source,
				});
			},
	},
);
